export const ManifestTabKeys = {
    OVERVIEW: 'overview',
    ENS: 'ens',
    DOCUMENTS: 'documents',
    NOTES: 'notes',
    HISTORY: 'history',
} as const;

export type ManifestTabKey = typeof ManifestTabKeys[keyof typeof ManifestTabKeys];
